import { useAccountList } from '@ltvco/refresh-lib/hooks';
import { LizanoListInfo } from '@ltvco/refresh-lib/v1';
import { AccountListsListItem } from '@ltvco/refresh-lib/v2';
import { useParams } from 'react-router-dom';

export function ListsItem() {
  const { data, isLoading } = useAccountList();
  const { listName } = useParams<{ listName: string }>();

  if (isLoading) {
    return null;
  }

  const list: LizanoListInfo | undefined = data?.find(
    ({ name }: { name: string }) => name === listName,
  ) as LizanoListInfo;

  return <AccountListsListItem list={list || []} />;
}
